<template>
  <div
    style="background: #0002300D; border-radius: 10px;"
    class="d-flex align-center px-6 py-1 mb-4 clickable"
    @click="
      $router.push({
        name: routeNames.TRANSACTION,
        params: {
          transaction: {
            ...transaction,
            settings: transactionSettings,
            currencySymbol,
          },
        },
      })
    "
  >
    <div>
      <v-btn style="width: 32px; height: 32px;" small fab plain class="white"
        ><v-icon
          v-if="transactionSettings"
          :class="transaction.type.toLowerCase()"
          style="font-size: 20px"
          >{{ transactionSettings.icon }}</v-icon
        ></v-btn
      >
    </div>
    <div style="color: var(--primary-color-blue); font-size: 12px; font-weight: 300;" class="px-5 flex-grow-1 font-weight-light">
      {{ formattedDate }}
    </div>
    <div
      v-if="transactionSettings"
      class="d-flex align-center font-weight-bold"
      :class="transaction.type.toLowerCase()"
      style="font-size: 14px !important"
    >
      <span
        >{{ transactionSettings.symbol }} {{ transactionSettings.amount }}</span
      >
      <v-icon
        v-if="transactionSettings.currencies.cash"
        class="pl-1"
        :class="transaction.type.toLowerCase()"
        style="font-size: 18px"
        >{{ currencySymbol }}
      </v-icon>
      <span
        v-if="
          transactionSettings.currencies.tokens &&
          transactionSettings.currencies.cash
        "
        style="font-size: 23px"
        class="px-1 font-weight-bold"
        >/</span
      >
      <v-icon
        v-if="transactionSettings.currencies.tokens"
        size="20"
        :class="transaction.type.toLowerCase()"
        class="ml-1"
      >
        local_activity
      </v-icon>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Transaction, transactionTypes } from "@/entities/app-data/Transaction";
import { whole, decimal } from "@/utils/MoneyUtils";
import { RequestService } from "../services/request.service";
import errorManager from "@/services/error.manager";

const requestService = new RequestService();

export default {
  props: {
    transaction: {
      Type: Transaction,
    },
    routeNames: {
      type: Object,
    },
  },
  computed: {
    ...mapState({
      currencySymbol: (state) =>
        state.customization.customization.economics.currency_symbol,
    }),
    formattedDate() {
      const date = moment(this.transaction.moment).locale(navigator.language);
      return date.format("D MMMM hh:mm");
    },
    transactionSettings() {
      let settings = {
        symbol: "+",
        currencies: {},
        icon: "",
        amount: "",
      };
      // Set + or - symbol
      if (
        this.transaction.type === transactionTypes.RECHARGE_REFUND ||
        this.transaction.type === transactionTypes.ORDER
      )
        settings.symbol = "-";
      // Set icon
      if (
        this.transaction.type == transactionTypes.RECHARGE_REFUND ||
        this.transaction.type == transactionTypes.ORDER_REFUND
      )
        settings.icon = "keyboard_return";
      if (
        this.transaction.type == transactionTypes.RECHARGE ||
        this.transaction.type == transactionTypes.TOKEN
      )
        settings.icon = "add";
      if (this.transaction.type == transactionTypes.ORDER)
        settings.icon = "arrow_upward";
      // Set currencies
      if (
        this.transaction.type === transactionTypes.ORDER ||
        this.transaction.type === transactionTypes.ORDER_REFUND
      ) {
        if (this.transaction.token_transactions.length) {
          settings.currencies.tokens = true;
        }
        if (this.transaction.amount) {
          settings.currencies.cash = true;
        }
      } else
        this.transaction.type === transactionTypes.TOKEN
          ? (settings.currencies.tokens = true)
          : (settings.currencies.cash = true);
      // Set amount
      if (this.transaction.type === transactionTypes.TOKEN)
        settings.amount = this.transaction.amount;
      else if (
        this.transaction.type === transactionTypes.ORDER &&
        settings.currencies.tokens &&
        !settings.currencies.cash
      )
        settings.amount = settings.currencies.total_tokens;
      else
        settings.amount =
          whole(this.transaction.amount) +
          this.$t("decimal_separator") +
          decimal(this.transaction.amount);
      return settings;
    },
  },
  methods: {
    whole,
    decimal,
  },
};
</script>
